// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { cardWrapperStyles } from "@synd/App/Components/TitledSection/TitledSection";
import LinkArrowRight from "@synd/XDL/Icons/LinkArrowRight";
import { avoidBreakInsidePrintElement, getSystemColor } from "@synd/XDL/Utilities";
import { css } from "styled-components";

cardWrapperStyles.container = {
    css: css`
        background-color: ${getSystemColor("common.ui1")};
        border: 1px solid ${getSystemColor("common.ui2")};
        border-radius: 8px;
        ${avoidBreakInsidePrintElement}
    `,
};

cardWrapperStyles.headerContainer = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        background-color: ${getSystemColor("common.ui8")};
        border-radius: 8px 8px 0 0;
        padding: 12px 16px;
        row-gap: 8px;
    `,
};

cardWrapperStyles.title = {
    variant: "h4",
    as: "p",
    css: css`
        margin: 0;
    `,
};

cardWrapperStyles.contentContainer = {
    css: css`
        padding: 16px;
    `,
};

cardWrapperStyles.button = {
    icon: {
        src: LinkArrowRight,
        position: "right",
    },
    css: css`
        ${IconWrapper} {
            top: 0;
            width: 8px;
            height: 13px;

            svg {
                width: 8px;
                height: 10px;
            }
        }
    `,
};
cardWrapperStyles.typographyContainer = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 8px;

        > ${IconWrapper} {
            margin: auto;
        }
    `,
};

cardWrapperStyles.secondaryText = {
    variant: "h6",
    as: "p",
    css: css`
        margin: 0;
    `,
};
